export const emailIpWarmingAppGroupIdPlanNameAvailable = "/email/ip_warming/:app_group_id/plan_name_available";
